@if (showSort() || showValueFilter()) {
  <button
    #triggerBtn
    type="button"
    class="kl-col-filter-trigger"
    [class.kl-col-filter-trigger--active]="filterState()?.active"
    (click)="toggle($event)">
    <i class="ph-fill ph-funnel"></i>
  </button>
}
@if (showSort() || showValueFilter()) {
  <div
    #filterPanel
    class="kl-col-filter-panel"
    [class.kl-col-filter-panel--sort-only]="showSort() && !showValueFilter()"
    [hidden]="!isOpen()"
    [style.top.px]="panelTop()"
    [style.left.px]="panelLeft()"
    (mousedown)="$event.stopPropagation()">
    @if (isOpen()) {
      @if (showSort()) {
        <div class="kl-col-filter__sort">
          <button type="button" class="kl-col-filter__sort-btn" (click)="onSortAsc()">
            &uarr; {{ 'ascending' | translate }}
          </button>
          &nbsp;&nbsp;&nbsp;
          <button type="button" class="kl-col-filter__sort-btn" (click)="onSortDesc()">
            &darr; {{ 'descending' | translate }}
          </button>
        </div>
      }
      @if (showValueFilter()) {
        <div class="kl-col-filter__body">
          <div class="kl-col-filter__search">
            <span class="ph ph-magnifying-glass kl-col-filter__search-icon"></span>
            <input
              type="text"
              class="kl-col-filter__search-input"
              [placeholder]="'search' | translate"
              [ngModel]="searchText()"
              (ngModelChange)="onSearchChange($event)"
              autocomplete="off" />
          </div>

          <div class="kl-col-filter__select-all">
            <label class="kl-col-filter__checkbox-label">
              <input
                type="checkbox"
                [checked]="selectAllChecked()"
                (change)="onSelectAllChange($any($event.target).checked)" />
              <span>{{ 'select_all' | translate }}</span>
            </label>
          </div>

          <div class="kl-col-filter__values">
            @for (item of valueItems(); track item.raw) {
              <div class="kl-col-filter__value-item">
                <label class="kl-col-filter__checkbox-label">
                  <input
                    type="checkbox"
                    [checked]="item.checked"
                    (change)="onItemChange(item, $any($event.target).checked)" />
                  <span>{{ item.caption }}</span>
                </label>
              </div>
            }
            @if (!valueItems().length) {
              <div class="kl-col-filter__empty">{{ 'no_data' | translate }}</div>
            }
          </div>
        </div>

        <div class="kl-col-filter__actions">
          <button
            type="button"
            class="kl-col-filter__action-btn kl-col-filter__action-btn--primary"
            (click)="applyFilter()">
            {{ 'apply' | translate }}
          </button>
          <button type="button" class="kl-col-filter__action-btn" (click)="cancelFilter()">
            {{ 'cancel' | translate }}
          </button>
          <button type="button" class="kl-col-filter__action-btn" (click)="clearFilter()">
            {{ 'clear' | translate }}
          </button>
        </div>
      }
      @if (showSort() && !showValueFilter()) {
        <div class="kl-col-filter__actions kl-col-filter__actions--single">
          <button type="button" class="kl-col-filter__action-btn" (click)="cancelFilter()">
            {{ 'close' | translate }}
          </button>
        </div>
      }
    }
  </div>
}
